const UUID_KEY = 'x-sh-uuid'

function setUUID(uuid: string) {
  localStorage.setItem(UUID_KEY, uuid)
}

function getUUID() {
  return localStorage.getItem(UUID_KEY) || ''
}

function deleteUUID() {
  localStorage.removeItem(UUID_KEY)
}

const uuidUtil = {
  setUUID,
  getUUID,
  deleteUUID,
  UUID_KEY,
}

export default uuidUtil
